var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLeaderboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_265_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 12.2168V13.5718C8.33018 13.8573 8.25373 14.1372 8.11131 14.3847C7.96889 14.6322 7.76528 14.839 7.52 14.9851C6.99928 15.3708 6.57569 15.8726 6.2829 16.4507C5.9901 17.0288 5.83617 17.6671 5.83333 18.3151",
    stroke: "#4B5563",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 12.2168V13.5718C11.6698 13.8573 11.7463 14.1372 11.8887 14.3847C12.0311 14.6322 12.2347 14.839 12.48 14.9851C13.0007 15.3708 13.4243 15.8726 13.7171 16.4507C14.0099 17.0288 14.1638 17.6671 14.1667 18.3151",
    stroke: "#4B5563",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 7.49967H16.25C16.8025 7.49967 17.3324 7.28018 17.7231 6.88948C18.1138 6.49878 18.3333 5.96888 18.3333 5.41634C18.3333 4.86381 18.1138 4.3339 17.7231 3.9432C17.3324 3.5525 16.8025 3.33301 16.25 3.33301H15",
    stroke: "#4B5563",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 18.333H16.6667",
    stroke: "#4B5563",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7.50033C5 8.82641 5.52678 10.0982 6.46447 11.0359C7.40215 11.9735 8.67392 12.5003 10 12.5003C11.3261 12.5003 12.5979 11.9735 13.5355 11.0359C14.4732 10.0982 15 8.82641 15 7.50033V2.50033C15 2.27931 14.9122 2.06735 14.7559 1.91107C14.5996 1.75479 14.3877 1.66699 14.1667 1.66699H5.83333C5.61232 1.66699 5.40036 1.75479 5.24408 1.91107C5.0878 2.06735 5 2.27931 5 2.50033V7.50033Z",
    stroke: "#4B5563",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00001 7.49967H3.75001C3.19747 7.49967 2.66757 7.28018 2.27687 6.88948C1.88617 6.49878 1.66667 5.96888 1.66667 5.41634C1.66667 4.86381 1.88617 4.3339 2.27687 3.9432C2.66757 3.5525 3.19747 3.33301 3.75001 3.33301H5.00001",
    stroke: "#4B5563",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_265_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLeaderboard);
export default __webpack_public_path__ + "static/media/ic_leaderboard.887004d4c3888e20ce273effbec4e8c9.svg";
export { ForwardRef as ReactComponent };